import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function QuickTestimonials() {
  const testimonials = [{
    text: 'Después de meses de tristeza, volvimos a hablar como antes.',
    author: 'Lucía M.',
    location: 'San Antonio'
  }, {
    text: 'Pensé que todo estaba perdido… hoy siento que recuperamos la complicidad.',
    author: 'Gabriela S.',
    location: 'Phoenix'
  }, {
    text: 'Entendí que era desconexión, no falta de amor. Nos sentimos más cerca.',
    author: 'Valentina L.',
    location: 'Dallas'
  }];
  return <section className="py-5 bg-gradient-to-b from-[#faf8f6] to-white" data-id="element-458">
      <div className="max-w-6xl mx-auto px-6" data-id="element-459">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-460">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2d2d2d] mb-4" data-id="element-461">
            Mira lo que dicen mujeres que ya lo leyeron
          </h2>
          <div className="w-20 h-1 bg-[#9d4b6b] mx-auto rounded-full" data-id="element-462"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-463">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white p-6 rounded-2xl shadow-xl shadow-[#9d4b6b]/5 border border-[#d4a5a5]/20 relative hover:shadow-2xl hover:shadow-[#9d4b6b]/10 transition-all duration-300" data-id="element-464">
              {/* Quote icon */}
              <div className="absolute -top-4 left-6" data-id="element-465">
                <div className="w-10 h-10 bg-[#9d4b6b] rounded-full flex items-center justify-center shadow-lg" data-id="element-466">
                  <Quote className="w-5 h-5 text-white fill-white" data-id="element-467" />
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4 mt-2" data-id="element-468">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#9d4b6b] fill-[#9d4b6b]" data-id="element-469" />)}
              </div>

              {/* Testimonial text */}
              <p className="text-[#2d2d2d] font-medium text-base leading-relaxed mb-6 italic" data-id="element-470">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t border-[#d4a5a5]/20 pt-4" data-id="element-471">
                <p className="text-[#9d4b6b] font-bold text-sm" data-id="element-472">
                  {testimonial.author}
                </p>
                <p className="text-[#8b6f6f] text-xs" data-id="element-473">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Persuasive CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center" data-id="element-474">
          <CTAButton fullWidth className="mb-3" data-id="element-475">
            QUIERO RECUPERAR MI RELACIÓN HOY
          </CTAButton>
          <p className="text-sm text-[#5a5a5a] mt-2" data-id="element-476">
            Únete a las mujeres que ya transformaron su relación
          </p>
        </motion.div>
      </div>
    </section>;
}